import React, { useEffect, useState } from 'react'
import { createContext } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { errorState } from '../../Redux/action'
import { Product_API } from '../../api'
export const Data = createContext()

const updatedUrl = (api, sort, order, subcategory, sortCategory, manufacturer, sliderVal) => {
    let url = api;

    if (sort){
        url = url + `&_sort=${sort}`;
    }
    if (sliderVal){
        url = url + `&actual_price_gte=${sliderVal[0]}&actual_price_lte=${sliderVal[1]}`; 
    }
    if (sortCategory){
        url = url + `&category=${sortCategory}`;
    }
    if (manufacturer){
        url = url + `&manufacturer=${manufacturer}`;
    }
    if (order){
        url = url + `&_order=${order}`;
    }
    if(subcategory){
        url = url + `&sub_category=${subcategory}`;
    }
    return url;
}


const DataContext = ({ children }) => {
    const Categories = [
        {
            cat: "Veterinary",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ["Petcare", "Farm Animals", "Poultry", "Aquaculture"]
        },
        {
            cat: "Ayush",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Homeopathy', 'Ayurvedic', 'Unani', 'Siddha']
        },
        {
            cat: "Fitness",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Vitamins And Supplements',
                'Family Nutrition',
                'Health Food And Drinks',
                'Ayurvedic Supplements',
                'Sports Supplements',
                'Smoking Cessation Support',
                'Weight Management']
        },
        {
            cat: "Mom & Baby",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Baby Care',
                'Feminine Hygiene',
                'Maternity Care',
                'Toys & Games',
                'Baby Bath Time',
                'Maternity Accessories']
        },
        {
            cat: "Treatments",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Diabetes Care',
                'First Aid',
                'Pain Relief Application',
                'Usual Symptoms',
                'General Discomfort',
                'Cough & Cold',
                'General Health Supplements',
                'Smoking Cessation (T)',
                'Skin Treatment']
        },
        {
            cat: "Devices",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Orthopaedics',
                'Breathe Easy',
                'Measurements',
                'Surgical Accessories']
        },
        {
            cat: "Eyewear",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Contact Lenses (EW)',
                'Eye Glasses',
                'Reading Glasses',
                'Sunglasses',
                'Computer Glasses']
        },
        {
            cat: "Covid Essentials",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Personal & Home Essentials',
                'Mask, Gloves & Protective Equipment',
                'Immunity Booster',
                'Business Essentials',
                'Travel Essentials',
                'Oxygen Can']
        },
        {
            cat: "Surgical",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Dressing',
                'Gi Care',
                'Iv Infusion',
                'Respiratory Supplies',
                'Surgical Consumables',
                'Surgical Instrument',
                'Urinary Care',
                'Wound Treatment']
        },
        {
            cat: "Diabetes Support",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Diabetes Care - Ayurveda',
                'Glucometers',
                'Lancets & Test Strips',
                'Sugar Substitutes',
                'Diabetes Management Supplements']
        },
        {
            cat: "Skin Care",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Cleansers',
                'Masks',
                'Moisturizers',
                'Sunscreen',
                'Eye Care',
                'Toners & Serums',
                'Aromatherapy',
                'Face Skin Care']
        },
        {
            cat: "Tools & Appliances",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Hair Styling Tools',
                'Face/Skin Tools',
                'Massage Tools']
        },
        {
            cat: "Personal Care",
            cat_image: "https://i.ibb.co/swYPsqv/cat-banner.gif",
            sub_cat: ['Bathing Accessories',
                'Face Personal Care',
                'Body Care',
                'Senior Care',
                'Lip Care',
                'Oral Care',
                'Bath & Shower',
                'Hands & Feet',
                'Home & Health',
                'Personal Care Tools & Accessories',
                'Eye Care Lens']
        }
    ]
    const [sliderVal, setSliderVal] = useState([0, 45000])
    const [prod, setProd] = useState([]);
    const [page, setPage] = useState(1);
    const [sort, setSort] = useState("");
    const [sortCategory, setSortCategory] = useState();
    const [total, setTotal] = useState(1747);
    const [currItem, setCurrItem] = useState(20);
    const [subCategory, setSubCategory] = useState("");
    const [order, setOrder] = useState("");
    const [manufacturer, setManufacturer] = useState('');
    const [loading, setLoading] = useState(false);
    const [currProduct, setCurrProduct] = useState({});
    const dispatch = useDispatch();

    const getProduct = (input=null) => {
        setLoading(true)
        let api;
        if (!input){
            api = updatedUrl(`${Product_API}?_page=${page}&_limit=40`, sort, order, subCategory, sortCategory, manufacturer, sliderVal)
        } else{
            api = `${Product_API}?q=${input}`;
        }
        console.log(api)
        axios.get(api)
            .then(res => {
                setLoading(false)
                // setTotal(res.headers['x-total-count'])
                setTotal(254144)
                setCurrItem(res.data.length)
                setProd(res.data)
            })
            .catch(() => dispatch(errorState()))
            .finally(() => {setLoading(false)})
    }
    const handlePriceRange = (val) => {
        setSliderVal(val)
    }
    const handlecurrProduct = (item) => {
        setCurrProduct(item)
    }

    useEffect(() => {
        getProduct()
    }, [page, sort, order, subCategory, sortCategory, manufacturer, sliderVal])

    const handleReset = (p, sub, categ, manu, slid) => {
        handlePage(p)
        handleSubCategory(sub)
        handleCategory(categ)
        handleManufacturer(manu)
        handlePriceRange(slid)
    }
    const handleSubCategory = (sub, p, manu, cat) => {
        handlePage(p)
        handleCategory(cat)
        handleManufacturer(manu)
        setSubCategory(sub)
    }
    const handleCategory = (val) => {
        setSortCategory(val)
    }
    const handleManufacturer = (val) => {
        setManufacturer(val)
    }

    const handlePage = (val) => {
        setPage(val);
    }
    const setval = (sortval, orderval) => {
        setSort(sortval);
        setOrder(orderval)
    }

    const val = {
        Categories, handleReset, setval, handlePage, handleManufacturer, handleSubCategory, getProduct, handleCategory, handlecurrProduct, currProduct, sortCategory, loading, prod, page, sort, currItem, total, manufacturer, order, handlePriceRange, sliderVal
    }
    return (
        <Data.Provider value={val}>
            {children}
        </Data.Provider>
    )
}

export default DataContext